import * as yup from 'yup';

export const SigSyncAppointmentEditFormValidationSchema = yup.object().shape(
  {
    status: yup.string().required()
  }
);
